const STORAGE_KEY = "csrp_complaints_list_state";

export function saveComplaintsListState(state) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore quota / private mode */
  }
}

export function readComplaintsListState() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearComplaintsListState() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Saved list snapshot when returning from SR detail (pendingRestore flag set). */
export function readComplaintsListRestoreSnapshot() {
  const saved = readComplaintsListState();
  if (!saved?.pendingRestore) return null;
  return saved;
}

export function markComplaintsListPendingRestore() {
  const saved = readComplaintsListState();
  if (!saved) return;
  saveComplaintsListState({ ...saved, pendingRestore: true });
}

export function markComplaintsListRestored() {
  const saved = readComplaintsListState();
  if (!saved) return;
  saveComplaintsListState({ ...saved, pendingRestore: false });
}
